import { dev } from 'src/app/config/offlines_keys.json';
import { PopoverImgComponent } from 'src/app/widgets/popover-img/popover-img.component';
import { LoginService } from '../../apis/login.service';
import { AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { LoadingController, ToastController } from '@ionic/angular';
import { Router } from '@angular/router';
import { CountriesService } from 'src/app/apis/countries.service';
import { PopoverComponent } from 'src/app/widgets/popover/popover.component';
import { PopoverController } from '@ionic/angular';
import { ToastUtils } from '../../utils/toast_builder';
import { mapLangeNameObjects } from 'src/app/utils/array-filtrer';
import { TranslateService } from '@ngx-translate/core';
import { Preferences } from '@capacitor/preferences';
import { Store } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import { environment } from 'src/environments/environment';
import { loadCountries } from 'src/app/utils/states-management/actions/countries.action';
import { CountriesState } from 'src/app/utils/states-management/reducers/countries.reducer';
import { ChannelSelectionPopoverComponent } from 'src/app/widgets/channel-selection-popover/channel-selection-popover.component';
import { AltchaService } from 'src/app/services/altcha.service';
import { TokenInterceptor } from 'src/app/apis/token.interceptor';
import { SessionTokenService } from 'src/app/apis/session-token.service';

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss'],
})
export class CreateAccountComponent implements OnInit, AfterViewInit {
  country: any;
  userCountry: any;
  mobile_number: any;
  code: any;
  countries = <any>[];
  countryName;
  network = '';
  lang;
  base_url = environment.appRoot;
  altcha_base_url = environment.appRoot + '/api/altcha-challenge';
  loadingModal;
  private countriesLoaded = false;  // Add this flag
  constructor(
    public LoginService: LoginService,
    public router: Router,
    public toastControllerComponent: ToastController,
    public countriesService: CountriesService,
    private popover: PopoverController,
    private zone: NgZone,
    public translateService: TranslateService,
    private toastUtils: ToastUtils,
    private store: Store<{ countries: CountriesState }>,
    private loadingCtrl: LoadingController,
    private altcha: AltchaService,
    // private tokenInterceptor: TokenInterceptor
  ) { }

  async ngOnInit(): Promise<void> {

    this.store.select('countries').subscribe(async (value) => {
      if (!this.countriesLoaded && value.list_countries.length == 0) {
        this.countriesLoaded = true;  // Set flag before dispatch
        this.store.dispatch(loadCountries());
      } else {
        this.countries = await mapLangeNameObjects(
          cloneDeep(value?.list_countries),
          this.translateService.currentLang
        );
        this.userCountry = cloneDeep(value?.user_country);
        this.country = this.userCountry;
        this.country.file_path = this.country?.file?.path
        this.countryName = this.translateService.instant(
          'countries.' + this.country.id
        );
        this.code = this.userCountry.indicatif;
      }
    });

    this.loadingModal = await this.loadingCtrl.create({
      spinner: 'bubbles',
      mode: 'ios',
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.registerCaptcha();
    }, 300);
  }

  async presentToast(message) {
    await this.toastUtils
      .toastBuilder(message, 'top', '', 'dark');
  }

  async presentToastGoLogin(message) {
    const toast = await this.toastControllerComponent.create({
      message: message,
      duration: 1000,
      position: 'top',
      color: 'dark',
      cssClass: 'custom-toast',
      buttons: [
        {
          side: 'end',
          text: await this.translateService
            .get('login')
            .toPromise()
            .then((value) => value),
          handler: () => {
            this.zone.run(() => {
              this.router.navigate(['/login']);
            });
          },
        },
      ],
    });
    toast.present();
  }

  changeIndicatif(event) {
    this.code = +event.target?.value?.indicatif;
  }

  async handelChangeCountrie(ev: any) {
    const popover = await this.popover.create({
      component: PopoverImgComponent,
      cssClass: 'pop-over-style-login-prefix',
      event: ev,
      translucent: true,
      componentProps: { data: this.countries, component: 'create-account1' },
    });
    popover.present();
    const { data } = await popover.onDidDismiss();
    if (data) {
      this.code = data.data.indicatif;
      this.country = data.data;
      this.countryName = this.translateService.instant(
        'countries.' + data.data.id
      );
      this.country.file_path = this.base_url + data?.data?.file?.path;
    } else {
      this.code = '';
    }
  }

  async handelChangeCountrieName(ev: any) {
    const popover = await this.popover.create({
      component: PopoverImgComponent,
      cssClass: 'pop-over-style-login',
      event: ev,
      translucent: true,
      componentProps: { data: this.countries, component: 'create-account2' },
    });
    popover.present();
    const { data } = await popover.onDidDismiss();
    if (data) {
      this.code = data.data.indicatif;
      this.country = data.data;
      this.countryName = this.translateService.instant(
        'countries.' + data.data.id
      );
      this.country.file_path = this.base_url + data?.data?.file?.path;
    } else {
      this.countryName = '';
    }
  }
  changeValue(mobile_number) {
    this.mobile_number = mobile_number.value;
  }
  async handelModalChoice() {
    const popover = await this.popover.create({
      component: ChannelSelectionPopoverComponent,
      cssClass: 'channel-selection-popover',
      componentProps: {
        phoneNumber: this.mobile_number.value,
        prefix: this.code
      },
      backdropDismiss: false
    });

    await popover.present();
    return popover;

  }
  selectedChannel = 'sms';
  async submitForm() {
    const altcha = document.querySelector('altcha-widget');

    // Trigger verification
    if (!this.captchaPayload) {
      await this.presentToast(
        await this.translateService.instant('errors.captcha')
      );
      return;
    }

    const form = new FormData();
    form.append('altcha_token', this.captchaPayload);

    form.append(
      'lang_key',
      this.translateService.currentLang
    );

    let lang = await (await Preferences.get({ key: dev.LANGAGE_KEY })).value;

    // if (this.code && this.code.length > 0) {
    this.code = this.code.toString();


    if (!this.mobile_number || !this.code || !this.userCountry?.id) {
      this.presentToast(
        await this.translateService
          .get('errors.all_fields')
          .toPromise()
          .then((value) => value)
      );
      return;
    } else if (
      isNaN(this.mobile_number) ||
      this.mobile_number.toString().length > 10 ||
      this.mobile_number.toString().length < 5
    ) {
      this.presentToast(
        await this.translateService.get('errors.mobile_number').toPromise()
      );
      return;
    } else {
      form.append('code', this.code);

      form.append('country_id', this.userCountry?.id);
      form.append('mobile_number', this.mobile_number);
      let popover = await this.handelModalChoice();
      const { data } = await popover.onDidDismiss();
      if (data.confirmed) {
        this.selectedChannel = data.channel;
        form.append('channel', this.selectedChannel);
      } else {
        return;
      }

      this.loadingModal.present();

      this.LoginService.register(form).subscribe(
        {
          next: async (response: any) => {
            await this.loadingModal.dismiss();

            if (response?.errors) {
              if (response.status === 409) {
                this.presentToastGoLogin(
                  await this.translateService
                    .instant(response?.errors)
                );
              } else if (response.status === 408) {

                this.presentToast(await this.translateService
                  .instant(response?.errors, { channel: this.selectedChannel }))

                this.handelModalChoice();
              } else {
                this.presentToast(await this.translateService
                  .instant(response?.errors))
              }

              return;
            }
            else {

              let componentProps = {
                key1: await this.translateService
                  .get('screens.create_account.click_sms_info_bull', { channel: this.selectedChannel })
                  .toPromise(),
                button_label: 'close',
              };
              let popover = await this.toastUtils.popOverBuilder(
                componentProps,
                PopoverComponent,
                'popover-custom'
              );
              popover.onDidDismiss();
              let network = this.network ? this.network : 'null';
              this.router.navigate([
                '/sms-validation/' +
                this.code +
                '/' +
                this.mobile_number +
                '/' +
                network +
                '/' +
                this.selectedChannel
              ]);
            }
          },
          error: async ({error}) => {
            await this.loadingModal.dismiss();
            console.log(error)
            this.presentToast(
              await this.translateService
                .instant(error?.errors)
            );

          },
        });

    }
  }
  @ViewChild('captcha') captcha;
  captchaPayload: string | null = null;

  async registerCaptcha() {
    this.captcha.nativeElement.configure({
      challengeurl: this.altcha_base_url,
      customfetch: (url, init) => {
        const match = document.cookie.match(new RegExp('(^|; )' + SessionTokenService.STORAGE_KEY + '=([^;]+)'));
        const sessionToken = match ? decodeURIComponent(match[2]) : null;
        init = init || {}
        init.headers = {
          ...(init.headers || {}),
          'X-Session-Token': sessionToken,
        }
        return fetch(url, init)
      }
    })
    let captchaLabel = await this.translateService.get('errors.captcha_label').toPromise();
    document.querySelector('.altcha-label').innerHTML = captchaLabel

    this.captcha.nativeElement.addEventListener('statechange', (ev) => {
      // console.log(ev.detail.state)
      if (ev.detail.state === 'verified') {

        this.captchaPayload = ev.detail.payload;
      }
    });
  }

  goBack() {
    this.router.navigate(['/terms']);
  }
}
